import { makeAutoObservable } from 'mobx'

class ContentPageStore {
  content: { title: string; content: string | undefined } | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setContentState(title: string, content: string | undefined) {
    this.content = {
      title,
      content,
    }
  }

  getContentPage() {
    return this.content
  }
}

export const contentPageStore = new ContentPageStore()
